import React from 'react';

import { container } from './styles.module.css';

export const FieldSet = ({ children }) => {
  return <div className={container}>{children}</div>;
};
